<template>
  <div class="footer">
    <div class="public">
      <el-row>
        <el-col :span="4">
          <div class="footer-logo">
            <img src="//cdnw2.acmcoder.com/release/exam/2.0.1/images/wlogo.png" />
          </div>
          <div class="text">丈量，不可估量的未来</div>
        </el-col>
        <el-col :span="8">
          <div class="footer-txt">
            <router-link to="/link/about">关于我们</router-link>
            <span class="division">|</span>
            <router-link to="/link/about?to=concat-user">联系我们</router-link>
            <span class="division">|</span>
            <router-link to="/link/state">免责声明</router-link>
            <span class="division">|</span>
            <secrect-control :onlyYingshi="true"/>
            <div class="copy-right" v-html="webconfig.copy">
              Copyright © acmcoder.com<br />All Rights Reversed
              京ICP备15012255-1
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="foot-right">
            <div class="footer-ewm">
              <img src="//cdnw2.acmcoder.com/release/www/2.0.1/images/ewm.png" />
              <div>企业微信</div>
            </div>
            <div class="footer-qq" style="position: relative; text-align: center;">
              <div>企业咨询</div>
              <div v-html="webconfig.Landline" class="blue">400-060-8006</div>
              <div class="radus" @click="Onqq">
                <i class="iconfont iconQQ"></i> &nbsp;<span
                  v-html="webconfig.qq"
                ></span>
              </div>
            </div>
            <div class="footer-qq gehe" style="position: relative; text-align: center;">
              <div>考生客服</div>
              <div v-html="webconfig.customerService" class="blue">
                010-85359782
              </div>
              <div class="radus" @click="Onqq">
                <span v-html="webconfig.qq2"></span> &nbsp;<i
                  class="iconfont iconQQ"
                ></i>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      webconfig: {
        // "Landline":"400-060-8006",
        // "customerService":"010-85359782",
        // "qq":"533869549"
      },
    }
  },
  computed: {
    loadConfig() {
      return this.$store.state.app.config
    },
  },
  mounted() {
    if (this.$store.state.app.config && this.$store.state.app.config.concat) {
      this.webconfig = this.$store.state.app.config.concat
      this.judgeDomainCopyRight()
      this.judgeCustomerService()
    }
  },
  watch: {
    loadConfig(newVal, oldVal) {
      if (newVal.concat) {
        this.webconfig = newVal.concat
        this.judgeDomainCopyRight()
        this.judgeCustomerService()
      }
    },
  },
  methods: {
    judgeCustomerService(){
      if (this.webconfig.customerService) {
        if (this.webconfig.customerService[this.domain]) {
          this.webconfig.customerService = this.webconfig.customerService[
            this.domain
          ]
        } else {
          this.webconfig.customerService = this.webconfig.customerService[
            'default'
          ]
        }
      }
    },
    judgeDomainCopyRight(){
      const hostname = location.host;
      const arr = hostname.split('.');
      let domain = '';
      if(arr.length > 2 && arr[0] == 'www'){
        domain = arr.slice(1).join('.');
      }
      else {
        domain = arr.join('.');
      }
      domain = domain.replace(/\./g, '_')
      this.domain = domain;
      if (this.webconfig.copy[domain]) {
        this.webconfig.copy = this.webconfig.copy[domain]
      } else {
        this.webconfig.copy = this.webconfig.copy['default']
      }
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURI(r[2]);
      } else {
        return null;
      }
    },
    Onqq() {
      window.open('tencent://message/?uin=10987654321')
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  // bottom: 0px;
  width: 100%;
  height: 173px;
  border-top: 1px solid #edf0f3;
  background: #3d444c;
  margin-top: 0px;
  color: #fff;
  font-family: 'Microsoft Yahei';
  .public {
    width: 1200px;
    margin: 0px auto;
    padding: 30px 0px 0px;
    a {
      color: #fff;
    }
    .text {
      opacity: 1;
      font-size: 14px;
      padding: 6px 0px 0px;
    }
    .footer-logo {
      width: 140px;
      opacity: 1;
      padding: 0px 0px 5px;
      img {
        width: 140px;
      }
    }
    .footer-txt {
      line-height: 25px;
      padding: 10px 20px 0 20px;
      font-size: 13px;
      a {
        text-decoration: none;
        padding: 0px 6px 0px 0px;
      }
      .division {
        padding: 0px 6px 0px 0px;
      }
      .copy-right {
        padding: 10px 0px 0px;
        color: #999;
        line-height: 26px;
      }
    }
    .foot-right {
      .footer-ewm {
        text-align: center;
        float: right;
        padding: 0px 0px 0px 30px;
        font-size: 12px;
        img {
          width: 100px;
          padding: 0px 0px 4px;
        }
      }
      .blue {
        color: #29bdb9;
      }
      .footer-qq {
        padding: 0px 20px 20px 15px;
        line-height: 32px;
        float: right;
        height: 110px;
        display: block;
        font-size: 14px;

        .radus {
          cursor: pointer;
          color: #fff;
          padding: 2px 15px;
          border: 1px solid #fff;
          border-radius: 20px;
          margin-top: 10px;
          line-height: 24px;
          display: initial;
        }
        &.gehe {
          border-right: 1px solid rgba(255, 255, 255, 0.2);
          text-align: right;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer/pc.vue